import React, { useEffect, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MoreIcon from '@material-ui/icons/MoreVert';

import { useLayoutContext } from '../../context';
import { useStyles } from './styles';

const Mobile = () => {
  const classes = useStyles();

  const { setMobileMoreAnchorEl, mobileMenuId } = useLayoutContext();

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const expiresIn = localStorage.getItem('@Gaia:expiresIn');

  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    if (expiresIn) {
      const intervalId = setInterval(() => {
        const now = new Date();
        const expirationTime = new Date(expiresIn * 1000);
        const timeLeft = expirationTime.getTime() - now.getTime();
        setCountdown(timeLeft > 0 ? timeLeft : 0);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [expiresIn]);

  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  if (countdown !== null) {
    hours = Math.floor((countdown / 1000 / 60 / 60) % 24);
    minutes = Math.floor((countdown / 1000 / 60) % 60);
    seconds = Math.floor((countdown / 1000) % 60);
  }

  return (
    <div className={classes.root}>
      <Grid style={{ marginTop: '15px' }}>
        {countdown !== null ? (
          <Typography variant='subtitle2'>
            {`Sessão expira em: ${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
              seconds < 10 ? '0' : ''
            }${seconds}`}
          </Typography>
        ) : (
          <Typography variant='subtitle2'>SESSÃO EXPIRADA</Typography>
        )}
      </Grid>
      <IconButton
        aria-label='show more'
        aria-controls={mobileMenuId}
        aria-haspopup='true'
        onClick={handleMobileMenuOpen}
        color='inherit'
      >
        <MoreIcon />
      </IconButton>
    </div>
  );
};

export default Mobile;
